import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from '../../../common/helpers'
import { withTranslation } from 'react-i18next'
import { Driller } from '../vca'
import PopupPresentational from './PopupPresentational'
import {
  saveSelectedVcaDeformed,
  resetSelectedVcaDeformed,
  saveHolesAfterEdit,
} from '../../../common/vca/actions'

const HOLE_FIELDS = ['startX', 'startY', 'endX', 'endY', 'diameter', 'depth']

const isEmpty = v => v === null || v === undefined || v === ''

const validateHoles = holes => {
  const errors = {}
  const visibleHoles = holes.filter(h => h.side === 'B' || h.side === 'R')

  visibleHoles.forEach(h => {
    const emptyFields = HOLE_FIELDS.filter(f => isEmpty(h[f]))
    if (emptyFields.length > 0 && emptyFields.length < HOLE_FIELDS.length) {
      errors[h.id] = emptyFields
    }
  })

  return { isValid: Object.keys(errors).length === 0, errors }
}

// eslint-disable-next-line
class DrillerPopup extends Component {
  state = {
    validationErrors: null,
  }

  componentDidUpdate(prevProps) {
    if (prevProps.holes !== this.props.holes) {
      const { isValid, errors } = validateHoles(this.props.holes)
      this.setState({ validationErrors: isValid ? null : errors })
    }
  }

  close = ({ ok } = {}) => {
    if (ok) {
      const { isValid, errors } = validateHoles(this.props.holes)
      if (!isValid) {
        this.setState({ validationErrors: errors })
        return
      }
      this.props.saveHolesAfterEdit()
    }

    this.props.close()
  }

  render() {
    const { t } = this.props
    const { validationErrors } = this.state
    return (
      <PopupPresentational
        title={t('drill data')}
        close={this.close}
        type="big"
        okText={t('save')}
        // hideCancel
        // cancelText="Zahodit změny"
        // showControlButtons={false}
        width="120"
        disableHistoryManipulation
        okDisabled={!!validationErrors}
      >
        <Driller validationErrors={validationErrors} />
      </PopupPresentational>
    )
  }
}

const enhance = compose(
  connect(
    state => ({
      holes: state.vca.holes,
    }),
    {
      saveSelectedVcaDeformed,
      resetSelectedVcaDeformed,
      saveHolesAfterEdit,
    },
  ),
  withTranslation(),
)

export default enhance(DrillerPopup)

DrillerPopup.defaultProps = {}

DrillerPopup.propTypes = {
  close: PropTypes.func.isRequired, // is injected by PopupsGate
  holes: PropTypes.array.isRequired,
  saveSelectedVcaDeformed: PropTypes.func.isRequired,
  resetSelectedVcaDeformed: PropTypes.func.isRequired,
  saveHolesAfterEdit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}
